import { render, staticRenderFns } from "./SupportTicketCloseButton.vue?vue&type=template&id=3fb5e365&"
import script from "./SupportTicketCloseButton.vue?vue&type=script&lang=js&"
export * from "./SupportTicketCloseButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports